import { ReactNode } from 'react'
import { cn } from '../lib/cn'

interface SectionProps {
  title?: string
  children: ReactNode
  className?: string
}

export const Section = ({ title, children, className }: SectionProps) => (
  <section className={cn('break-inside-avoid', className)}>
    {title && (
      <h2 className='mb-2 text-[9pt] font-semibold uppercase tracking-wide text-zinc-500'>
        {title}
      </h2>
    )}
    {children}
  </section>
)
